var _a;
window._nc_vue_element_id = (_a = window._nc_vue_element_id) != null ? _a : 0;
function createElementId() {
  return "nc-vue-".concat(window._nc_vue_element_id++);
}
export {
  createElementId as c
};
//# sourceMappingURL=createElementId-5skgwxOP.mjs.map
